import { Directive, HostListener, Input } from '@angular/core';
import { CommonService } from '../services/commonService';
import { IVinValidationContext } from '../modal/IVinValidationContext';
import { emptyModal } from '../modal/DAO';

@Directive({
  selector: '[VinVerifier]'
})

export class VinCheckerDirective {
  @Input("VinVerifier") params!: [emptyModal, string] | null;

  constructor(private commonService: CommonService) { }

  // This directive will be triggered on the user's first action anywhere after completing the VIN entry. 
  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value?.trim();
    if (!value)
      return;

    if (!this.params)
      return;

    const payload = {
      urlData: [this.params[1]], // reference number
      payloadData: [
        {
          vin: this.params[0].answer.trim(),
          group: this.params[0].group
        }
      ]
    };

    this.commonService.post('vehicle', 'validateVins', payload, false).toPromise()
      .then((response: IVinValidationContext[]) => {
        response.forEach(context => {
          this.params[0].status = context.checkedStatus ?? "";
        });
      })
      .catch(error => {
        console.error('Error while validating VINs:', error);
      });
  }
}